import React from 'react';
import { Footer, Header } from '../component';
import { checkMobileDevice } from '../utils/utility';
import { Outlet } from 'react-router';

const GeneralLayout = () => {
  return (
    <>
      <Header />
      <main className="bg-third-light h-min-60vh position-relative ">
        <Outlet />
      </main>
      {checkMobileDevice() ? <></> : <Footer />}
    </>
  );
};
export default GeneralLayout;
